import { css } from '@emotion/react';
import { Blue, Gray, White } from '@constants/color';

export const container = css({
  display: 'flex',
  flexDirection: 'row',
  width: '1920px',
  height: '1080px'
});

export const mainContainer = css({
  display: 'flex',
  flexDirection: 'column',
  padding: '64px',
  width: '1152px'
});

export const rightContainer = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  rowGap: '40px',
  padding: '180px 64px',
  width: '512px',
  backgroundColor: Gray.Gray90
});

export const rightButtonContainer = css({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '40px',
  width: '100%'
});

export const title = css({
  marginTop: 60,
  color: White.White10,
  fontSize: '48px',
  fontWeight: 700
});

export const content = css({
  marginTop: 80,
  color: Gray.Gray40,
  fontSize: '32px',
  fontWeight: 500
});

export const subContent = css({
  marginTop: 8,
  color: Blue.Blue40,
  fontSize: '48px',
  fontWeight: 700
});

export const description = css({
  marginTop: 40,
  color: White.White10,
  fontSize: '40px',
  fontWeight: 700
});

export const subtitle = css({
  color: White.White10,
  fontSize: '32px',
  fontWeight: 700
});
